import Badge from '../Badge';
import type { OrderStatusBadgeProps } from './OrderStatusBadge.types';
import type { BadgeVariant } from '../Badge/Badge.types';

const MAP: Record<string, { label: string; variant: BadgeVariant }> = {
  new:         { label: 'Новый',          variant: 'info' },
  pending:     { label: 'Ожидает',        variant: 'neutral' },
  in_progress: { label: 'В работе',       variant: 'brand' },
  on_review:   { label: 'На проверке',    variant: 'warning' },
  on_hold:     { label: 'Приостановлен',  variant: 'warning' },
  completed:   { label: 'Завершён',       variant: 'success' },
  delivered:   { label: 'Доставлен',      variant: 'success' },
  cancelled:   { label: 'Отменён',        variant: 'danger' },
  rejected:    { label: 'Отклонён',       variant: 'danger' },
};

export default function OrderStatusBadge({ status, className, size = 'md' }: OrderStatusBadgeProps) {
  const cfg = MAP[status] ?? { label: status, variant: 'neutral' as BadgeVariant };
  return (
    <Badge variant={cfg.variant} size={size} className={className}>
      {cfg.label}
    </Badge>
  );
}
